import {
  Button,
  Checkbox,
  Col,
  Form,
  message,
  Modal,
  Row,
  Spin,
  Table,
  Typography,
} from "antd";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import COLORS from "common/Colors";
import { uniqBy } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getAllDepartmentList,
  getClientid,
  getIsShowAgain,
  getLocations,
  getMenuList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import styled from "styled-components";
import { EditOutlined } from "@mui/icons-material";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { render } from "less";
import { CALL_API } from "common/API";
import dayjs from "dayjs";
import { STATUS_CODE } from "common/Constants";
import ShiftInfo from "./ShiftInfo";
import { utils, writeFileXLSX } from "xlsx";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { saveIsShowAgain, setShiftList } from "redux/actions";
import moment from "moment";
import { bindActionCreators } from "redux";
const { Text } = Typography;

const ShiftManagementWrap = styled.div`
  .header-view {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .change-view {
    color: #2d53da;
    border-radius: 10px;
  }
  .change-view:disabled {
    color: #e3e8fc !important;
  }
  .change-view: hover {
    background: #c5cff5;
  }
  @media (max-width: 426px) {
    .header-view {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const ShiftManagement = ({ saveShiftList }) => {
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const getShowAgain = useSelector(getIsShowAgain);
  const containerRef = useRef(null);
  const departmentList = useSelector(getAllDepartmentList);
  const locationList = useSelector(getLocations);
  const ClientId = useSelector(getClientid);
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [shiftList, setShiftList] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [filterShiftList, setFilterShiftList] = useState([]);
  const [isViewInfo, setIsViewInfo] = useState(false);
  const [selectedShift, setSelectedShift] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const findUser = userList?.find((val) => val?.userid === userInfo?.userid);

  const userTimeZone =
    locationList?.find((val) => val?.location_id === findUser?.baselocationid)
      ?.usertimezone || "Africa/Nairobi";

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getShiftList = async () => {
    try {
      setLoader(true);
      const { data } = await CALL_API(`get-shift/${ClientId}`, "get", {});
      setShiftList(data);
      saveShiftList(data);
      setLoader(false);
    } catch (error) {
      console.log("[getDepartmentList], Error-->", error);
    }
  };

  const handleRemove = async (id) => {
    try {
      setConfirmLoading(true);
      const { code } = await CALL_API(
        `delete-shift/${ClientId}/${id}`,
        "delete",
        {
          statusid: "1",
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        message.success("Shift deleted successfully.");
        getShiftList();
      } else {
        setIsModalVisible(true);
      }
      dispatch(
        saveIsShowAgain({ deleteShift: form?.getFieldValue("deleteshift") })
      );
    } catch (error) {
      message.error("Something went wrong.");
    } finally {
      setConfirmLoading(false);
    }
  };

  const showDeleteConfirm = (id) => {
    if (getShowAgain?.deleteShift) {
      handleRemove(id);
    } else {
      Modal.confirm({
        title: "Are you sure you want to Remove this Shift?",
        content: (
          <Form
            form={form}
            name="isShowagain"
            layout="vertical"
            initialValues={{ deleteshift: getShowAgain?.deleteShift }}
          >
            <Form.Item name="deleteshift" valuePropName="checked">
              <Checkbox
                disabled={false}
                style={{ color: "#5d5f68", fontWeight: 500 }}
              >
                Don't show this again
              </Checkbox>
            </Form.Item>
          </Form>
        ),
        okText: "Yes, Remove",
        cancelText: "No, Cancel",
        okButtonProps: {
          loading: confirmLoading,
        },
        onOk: async () => {
          handleRemove(id);
        },
      });
    }
  };

  const columns = [
    {
      title: "Shift title",
      dataIndex: "shifttitle",
      key: "shifttitle",
    },
    {
      title: "Timing",
      dataIndex: "starts",
      key: "starts",
      render: (text, record) => {
        // any valid date
        return (
          <span>
            {dayjs(record?.starts).format("hh:mm A")} -{" "}
            {dayjs(record?.ends).format("hh:mm A")}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        return text === "active"
          ? "Active"
          : text === "inactive"
          ? "Inactive"
          : "-";
      },
    },
    // {
    //   title: "No. of Location",
    //   dataIndex: "location",
    //   key: "location",
    //   render: (text, record) => {
    //     return <span>{text?.length || "0"}</span>;
    //   },
    // },
    // {
    //   title: "No. of Department",
    //   dataIndex: "department",
    //   key: "department",
    //   render: (text, record) => {
    //     return <span>{text?.length || "0"}</span>;
    //   },
    // },
    {
      title: "Created on",
      dataIndex: "inserted_at",
      key: "inserted_at",
      render: (text, record) => {
        return (
          <>
            <span>{record?.createduser}</span>
            {""}
            <span>{` (${record?.ceratedemployeeid})`}</span>
            <br></br>

            <small>
              <i>
                {text
                  ? moment
                      .utc(text)
                      .tz(userTimeZone)
                      .format("Do MMM, YYYY; hh:mm A")
                  : "-"}
              </i>
            </small>
          </>
        );
      },
    },
    {
      title: "Last Updated on",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text, record) => {
        return text ? (
          <>
            <span>{record?.updateduser}</span>
            {""}
            <span>{` (${record?.updatedemployeeid})`}</span>
            <br></br>
            <small>
              <i>
                {moment
                  .utc(text)
                  .tz(userTimeZone)
                  .format("Do MMM, YYYY; hh:mm A") || "-"}
              </i>
            </small>
          </>
        ) : (
          <div className="text-center w-100">-</div>
        );
      },
    },
    {
      title: "",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text, record) => (
        <>
          {Menulist?.find(
            (item) =>
              item?.key === "manage" &&
              item?.subMenu.find(
                (subItem) =>
                  subItem?.key === "shift" && subItem?.permission.edit
              )
          ) && (
            <Edit
              style={{ cursor: "pointer", marginRight: "10px" }}
              corlor="red"
              onClick={() =>
                history?.push("editshift", {
                  shiftData: record,
                  shiftColors: shiftColors,
                })
              }
            />
          )}
          {Menulist?.find(
            (item) =>
              item?.key === "manage" &&
              item?.subMenu.find(
                (subItem) =>
                  subItem?.key === "shift" && subItem?.permission.delete
              )
          ) && (
            <Trash
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                showDeleteConfirm(record?.shift_id);
              }}
            />
          )}
        </>
      ),
    },
  ];

  const handleFormChange = () => {
    const values = form.getFieldsValue();

    // If both filters are empty, show the full list
    if (
      (!values?.department || values.department.length === 0) &&
      (!values?.location || values.location.length === 0)
    ) {
      setFilterShiftList(shiftList);
      return;
    }

    const shiftFilter = shiftList.filter((shift) => {
      const departmentMatch =
        !values.department?.length ||
        shift.department.some((deptId) => values.department.includes(deptId));

      const locationMatch =
        !values.location?.length ||
        shift.location.some((locId) => values.location.includes(locId));

      return departmentMatch && locationMatch;
    });

    setFilterShiftList(shiftFilter);
  };

  const shiftColors = useMemo(() => {
    return shiftList?.map((item) => item?.color);
  }, [shiftList]);

  const xport = React.useCallback(() => {
    const elt = document.getElementById("Table");
    const wb = utils.table_to_book(elt);
    writeFileXLSX(wb, "Shift.xlsx");
  });

  useEffect(() => {
    getShiftList();
  }, []);

  useEffect(() => {
    handleFormChange();
  }, [shiftList]);

  return (
    <ShiftManagementWrap>
      <div className="header-view">
        <h5 className="">Shift</h5>
        <div className="header-buttons">
          <Button
            type="link"
            className="change-view"
            onClick={() =>
              history.push("peopleview", {
                shiftColors: shiftColors,
                shiftList: shiftList,
              })
            }
          >
            People View
          </Button>
          <ButtonOutlined
            disabled={filterShiftList?.length === 0}
            onClick={xport}
          >
            Export CSV File
          </ButtonOutlined>
          <ButtonFilled
            type="primary"
            onClick={() =>
              history.push("addshift", {
                shiftColors: shiftColors,
              })
            }
            disabled={
              !Menulist?.find(
                (item) =>
                  item?.key === "manage" &&
                  item?.subMenu.find(
                    (subItem) =>
                      subItem?.key === "shift" && subItem?.permission.create
                  )
              )
            }
          >
            + Add Shift
          </ButtonFilled>
        </div>
      </div>

      {/* <Form
        form={form}
        layout="vertical"
        className="mt-2"
        onValuesChange={handleFormChange}
      >
        <Row gutter={12} className="g-3 mb-2">
          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="department"
              label="Department"
              options={uniqBy(
                departmentList?.map((item) => {
                  return {
                    label: item?.department_name,
                    value: item?.department_id,
                  };
                }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>

          <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
            <DropdownCheckBox
              name="location"
              label="Location"
              options={uniqBy(
                locationList
                  ?.filter((item) => item?.login_from_anywhere !== 1)
                  .map((item) => {
                    return {
                      label: item?.location_name,
                      value: item?.location_id,
                    };
                  }),
                "value"
              )}
              form={form}
              handleFormChange={handleFormChange}
            />
          </Col>
        </Row>
      </Form> */}
      <label>Total Shift: {shiftList?.length}</label>
      <Spin spinning={loader}>
        <StyledTable
          dataSource={filterShiftList?.reverse()}
          columns={columns}
          className="mt-2"
          // note : first parameter is needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="userid"
          pagination={false}
          onRow={(record) => {
            return {
              onClick: () => {
                setIsViewInfo(true);
                setSelectedShift(record);
              },
            };
          }}
          id="Table"
        />
      </Spin>
      <ShiftInfo
        open={isViewInfo}
        setOpen={setIsViewInfo}
        data={selectedShift}
        getShiftList={getShiftList}
        shiftColors={shiftColors}
        showDeleteConfirm={showDeleteConfirm}
        Menulist={Menulist}
      />
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        closable
      >
        <div style={{ textAlign: "center", padding: "20px" }}>
          <ExclamationCircleFilled style={{ fontSize: 48, color: "#FF4D4F" }} />
          <div style={{ marginTop: 20 }}>
            <Text>
              You cannot delete this shift because some active employees are
              still assigned to it. Please reassign their shifts before
              proceeding with deletion.
            </Text>
          </div>
        </div>
      </Modal>
    </ShiftManagementWrap>
  );
};
const mapStateToProps = (state) => ({
  userList: getUserList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveShiftList: setShiftList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(ShiftManagement);
